import { useEffect, useState } from "react";

// Founder's Day 2026 — 22–24 October, IST (Asia/Kolkata, UTC+5:30, no DST).
const IST_MIN = 330;
const START = Date.UTC(2026, 9, 21, 18, 30); // Oct 22, 00:00 IST
const END = Date.UTC(2026, 9, 24, 18, 30); // Oct 25, 00:00 IST

// Hidden preview override: append ?fdemo=before|live|after to the URL.
function previewOverride() {
  if (typeof window === "undefined") return null;
  const p = new URLSearchParams(window.location.search).get("fdemo");
  return ["before", "live", "after"].includes(p) ? p : null;
}

export function getEventState(now = Date.now()) {
  const preview = previewOverride();
  if (preview) {
    if (preview === "live") return { phase: "live", day: 1, days: 3 };
    return { phase: preview, day: 0, days: 3 };
  }
  if (now >= START && now < END) {
    const day = new Date(now + IST_MIN * 60000).getUTCDate() - 21; // Oct 22→1 … Oct 24→3
    return { phase: "live", day, days: 3 };
  }
  return { phase: now >= END ? "after" : "before", day: 0, days: 3 };
}

export function useEventState(pollMs = 30000) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), pollMs);
    return () => clearInterval(t);
  }, [pollMs]);
  return getEventState(now);
}

export const EVENT_START = START;
